/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AggregateKeyInfo } from './AggregateKeyInfo';
import {
    AggregateKeyInfoFromJSON,
    AggregateKeyInfoFromJSONTyped,
    AggregateKeyInfoToJSON,
} from './AggregateKeyInfo';
import type { BooleanSearch } from './BooleanSearch';
import {
    BooleanSearchFromJSON,
    BooleanSearchFromJSONTyped,
    BooleanSearchToJSON,
} from './BooleanSearch';
import type { Int32ListSearch } from './Int32ListSearch';
import {
    Int32ListSearchFromJSON,
    Int32ListSearchFromJSONTyped,
    Int32ListSearchToJSON,
} from './Int32ListSearch';
import type { TextSearch } from './TextSearch';
import {
    TextSearchFromJSON,
    TextSearchFromJSONTyped,
    TextSearchToJSON,
} from './TextSearch';
import type { UnaccentTextSearch } from './UnaccentTextSearch';
import {
    UnaccentTextSearchFromJSON,
    UnaccentTextSearchFromJSONTyped,
    UnaccentTextSearchToJSON,
} from './UnaccentTextSearch';

/**
 * 
 * @export
 * @interface TuteurSearchDto
 */
export interface TuteurSearchDto {
    /**
     * 
     * @type {number}
     * @memberof TuteurSearchDto
     */
    idlieuformation?: number | null;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof TuteurSearchDto
     */
    nom?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof TuteurSearchDto
     */
    prenom?: UnaccentTextSearch;
    /**
     * 
     * @type {Int32ListSearch}
     * @memberof TuteurSearchDto
     */
    idmetier?: Int32ListSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof TuteurSearchDto
     */
    lieuFormation?: UnaccentTextSearch;
    /**
     * 
     * @type {BooleanSearch}
     * @memberof TuteurSearchDto
     */
    actif?: BooleanSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof TuteurSearchDto
     */
    nomApprenant?: UnaccentTextSearch;
    /**
     * 
     * @type {UnaccentTextSearch}
     * @memberof TuteurSearchDto
     */
    prenomApprenant?: UnaccentTextSearch;
    /**
     * 
     * @type {TextSearch}
     * @memberof TuteurSearchDto
     */
    registreNationalOrEmpty?: TextSearch;
    /**
     * 
     * @type {Array<string>}
     * @memberof TuteurSearchDto
     */
    sortKey?: Array<string> | null;
    /**
     * 
     * @type {Array<AggregateKeyInfo>}
     * @memberof TuteurSearchDto
     */
    aggregateKeys?: Array<AggregateKeyInfo> | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurSearchDto
     */
    forceSkip?: number | null;
    /**
     * 
     * @type {number}
     * @memberof TuteurSearchDto
     */
    forceTake?: number | null;
    /**
     * 
     * @type {any}
     * @memberof TuteurSearchDto
     */
    parameters?: any | null;
    /**
     * 
     * @type {string}
     * @memberof TuteurSearchDto
     */
    filter?: string | null;
}

/**
 * Check if a given object implements the TuteurSearchDto interface.
 */
export function instanceOfTuteurSearchDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function TuteurSearchDtoFromJSON(json: any): TuteurSearchDto {
    return TuteurSearchDtoFromJSONTyped(json, false);
}

export function TuteurSearchDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TuteurSearchDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idlieuformation': !exists(json, 'idlieuformation') ? undefined : json['idlieuformation'],
        'nom': !exists(json, 'nom') ? undefined : UnaccentTextSearchFromJSON(json['nom']),
        'prenom': !exists(json, 'prenom') ? undefined : UnaccentTextSearchFromJSON(json['prenom']),
        'idmetier': !exists(json, 'idmetier') ? undefined : Int32ListSearchFromJSON(json['idmetier']),
        'lieuFormation': !exists(json, 'lieuFormation') ? undefined : UnaccentTextSearchFromJSON(json['lieuFormation']),
        'actif': !exists(json, 'actif') ? undefined : BooleanSearchFromJSON(json['actif']),
        'nomApprenant': !exists(json, 'nomApprenant') ? undefined : UnaccentTextSearchFromJSON(json['nomApprenant']),
        'prenomApprenant': !exists(json, 'prenomApprenant') ? undefined : UnaccentTextSearchFromJSON(json['prenomApprenant']),
        'registreNationalOrEmpty': !exists(json, 'registreNationalOrEmpty') ? undefined : TextSearchFromJSON(json['registreNationalOrEmpty']),
        'sortKey': !exists(json, 'sortKey') ? undefined : json['sortKey'],
        'aggregateKeys': !exists(json, 'aggregateKeys') ? undefined : (json['aggregateKeys'] === null ? null : (json['aggregateKeys'] as Array<any>).map(AggregateKeyInfoFromJSON)),
        'forceSkip': !exists(json, 'forceSkip') ? undefined : json['forceSkip'],
        'forceTake': !exists(json, 'forceTake') ? undefined : json['forceTake'],
        'parameters': !exists(json, 'parameters') ? undefined : json['parameters'],
        'filter': !exists(json, 'filter') ? undefined : json['filter'],
    };
}

export function TuteurSearchDtoToJSON(value?: TuteurSearchDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idlieuformation': value.idlieuformation,
        'nom': UnaccentTextSearchToJSON(value.nom),
        'prenom': UnaccentTextSearchToJSON(value.prenom),
        'idmetier': Int32ListSearchToJSON(value.idmetier),
        'lieuFormation': UnaccentTextSearchToJSON(value.lieuFormation),
        'actif': BooleanSearchToJSON(value.actif),
        'nomApprenant': UnaccentTextSearchToJSON(value.nomApprenant),
        'prenomApprenant': UnaccentTextSearchToJSON(value.prenomApprenant),
        'registreNationalOrEmpty': TextSearchToJSON(value.registreNationalOrEmpty),
        'sortKey': value.sortKey,
        'aggregateKeys': value.aggregateKeys === undefined ? undefined : (value.aggregateKeys === null ? null : (value.aggregateKeys as Array<any>).map(AggregateKeyInfoToJSON)),
        'forceSkip': value.forceSkip,
        'forceTake': value.forceTake,
        'parameters': value.parameters,
        'filter': value.filter,
    };
}

